import * as React from "react";

function SatoshiV2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.91h10M12 5.455V3M12 21v-2.455M7 12h10M7 16.09h10"
  }));
}

export default SatoshiV2Icon;